import { render, staticRenderFns } from "./OfficeBizException.vue?vue&type=template&id=164e5690&scoped=true&"
import script from "./OfficeBizException.vue?vue&type=script&lang=js&"
export * from "./OfficeBizException.vue?vue&type=script&lang=js&"
import style0 from "./OfficeBizException.vue?vue&type=style&index=0&id=164e5690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164e5690",
  null
  
)

export default component.exports